import { createContext, useContext } from 'react';

/** Ce que la barre superieure demande a la palette : s'ouvrir. */
export interface CommandPaletteControls {
  readonly open: () => void;
}

export const CommandPaletteContext = createContext<CommandPaletteControls | null>(null);

export const useCommandPalette = (): CommandPaletteControls => {
  const controls = useContext(CommandPaletteContext);

  if (controls === null) {
    throw new Error('useCommandPalette doit etre utilise sous CommandPaletteProvider.');
  }

  return controls;
};
